import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import {DocumentsListRoute} from "../../routesConstants";
import DocumentsForm from "./documentsForm";
import Loader from "../../../components/loader";
import {noDispHeader} from "../../../helpers/errorTranslate";

const EditModal = ({id,children}) => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [currentId, setCurrentId] = useState(id)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getDocData = (id) =>{
    setLoading(true)
    setCurrentId(id)
    console.log('get new')
    axios.get('/api/documents/'+id,{headers:noDispHeader})
      .then(({data})=>{
        console.log(data)
        setData({...data.document, photos: data.document.photos.map(l=>({url:l}))})
        setLoading(false)
      })
      .catch(sayError)
  }
  useEffect(() => {
    if(currentId && show){
      getDocData(id)
    }
  }, [id,show]);
  const onSubmit = (dataInfo) =>{
    setLoading(true)
    console.log('submit', dataInfo)
    let sendingInfo = {...dataInfo}
    sendingInfo.photos = dataInfo.photos.map(l=>(l.url))
    axios.patch('/api/documents/'+currentId, sendingInfo,{headers:noDispHeader})
      .then(({data})=>{
        console.log(data)
        if(data.nextDoc){
          setData()
          getDocData(data.nextDoc)
        }else{
          handleClose()
          setData(null)
        }

      })
      .catch(sayError)
      .finally(()=>setLoading(false))
  }

  return (
    <>
      <div onClick={handleShow} className={'link-info'} style={{cursor:'pointer'}}>{children}</div>
      <Modal show={show} dialogClassName="modal-90w" onHide={handleClose}>
        <Modal.Header closeButton>
          {/*<Modal.Title>Галерея</Modal.Title>*/}
        </Modal.Header>
        <Modal.Body >
          {data ?
            <DocumentsForm data={data}
                           onSubmit={onSubmit}
                           loading={loading}
                           title={'Редактировать информацию по документу'}/>: <Loader/>
          }
        </Modal.Body>
      </Modal>

    </>
  );
};

export default EditModal;
